import { store } from '../redux/store';

export class CheckoutRequest {
  static getTokenRequest(cardData) {
    const meta = store.getState().metadata.object;
    const [expiryMonth, expiryYear] = cardData.expiry_date.split('/');
    return {
      type: 'card',
      number: cardData?.card_number,
      expiry_month: expiryMonth,
      expiry_year: expiryYear,
      name: cardData?.card_holder_name,
      cvv: cardData?.card_security_code,
      ...(meta?.countryCode
        ? {
            phone: {
              country_code: meta?.countryCode,
              number: meta?.phoneNumber,
            },
          }
        : undefined),
    };
  }
  static getPaymentRequest(token) {
    const meta = store.getState().metadata.object;
    return {
      subscriptionId: meta.subscriptionId,
      card_token: token,
    };
  }
}
